import { Component } from '@angular/core';
import { NineSlicedSpriteComponent } from '@features/sprites/nine-sliced-sprite/nine-sliced-sprite.component';

@Component({
  selector: 'app-sprites',
  imports: [NineSlicedSpriteComponent],
  templateUrl: './sprites.component.html',
  styleUrl: './sprites.component.css',
})
export class SpritesComponent {}
